module.exports = {"title":"Station","outlet_details":"Station Details","create_outlet":"Create New Station","pricebook":"Main Pricebook","central_devices":"Devices","outlet_count":"{1} :value station|[2,*] :value stations","delete_success":"Station has been successfully deleted","delete_text":"This will also delete device associated with this station. Continue ?"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/outlet.php
// module id = I0Im
// module chunks = 99